export default [{
  path: "/reports",
  name: "Reports",
  component: () => import("@/pages/reports/Index.vue")
},
{
  path: "/reports/balance-sheet",
  name: "BalanceSheetReport",
  component: () => import("@/pages/reports/BalanceSheet.vue")
},
{
  path: "/reports/balance-sheet-ytd-summary",
  name: "BalanceSheetYTDReport",
  component: () => import("@/pages/reports/BalanceSheetYTDSummary.vue")
},
{
  path: "/reports/balance-sheet-consolidation",
  name: "BalanceSheetConsolidationReport",
  component: () => import("@/pages/reports/BalanceSheetConsolidation.vue")
},
{
  path: "/reports/account-schedule-consolidation",
  name: "AccountScheduleConsolidationReport",
  component: () => import("@/pages/reports/AccountScheduleConsolidation.vue")
},
{
  path: "/reports/trial-balance",
  name: "TrialBalanceReport",
  component: () => import("@/pages/reports/TrialBalance.vue")
}, {
  path: "/reports/profit-and-loss",
  name: "ProfitAndLossReport",
  component: () => import("@/pages/reports/ProfitAndLoss.vue")
}, {
  path: "/reports/profit-and-loss/consolidation/current-month",
  name: "ProfitAndLossCurrentMonthConsolidationReport",
  component: () => import("@/pages/reports/ProfitAndLossCurrentMonthConsolidation.vue")
}, {
  path: "/reports/profit-and-loss/consolidation/ytd",
  name: "ProfitAndLossYTDConsolidationReport",
  component: () => import("@/pages/reports/ProfitAndLossYTDConsolidation.vue")
}, {
  path: "/reports/profit-and-loss/summary/ytd",
  name: "ProfitAndLossYTDSummaryReport",
  component: () => import("@/pages/reports/ProfitAndLossYTDSummary.vue")
}, {
  path: "/reports/cash-flow",
  name: "CashFlowReport",
  component: () => import("@/pages/reports/CashFlow.vue")
}, {
  path: "/reports/cash-flow/summary/ytd",
  name: "CashFlowYTDSummaryReport",
  component: () => import("@/pages/reports/CashFlowYTDSummary.vue")
}, {
  path: "/reports/cash-flow-by-department",
  name: "CashFlowByDepartmentReport",
  component: () => import("@/pages/reports/CashFlowByDepartment.vue")
}, {
  path: "/reports/account-payable-aging",
  name: "ApAgingReport",
  component: () => import("@/pages/reports/AccountPayableAging.vue")
}, {
  path: "/reports/account-receivable-aging",
  name: "ArAgingReport",
  component: () => import("@/pages/reports/AccountReceivableAging.vue")
}, {
  path: "/reports/account-receivable-aging-cc",
  name: "ArAgingReportCC",
  component: () => import("@/pages/reports/AccountReceivableAgingCC.vue")
}, {
  path: "/reports/account-receivable-aging-card-ledger",
  name: "ArAgingReportCardLedger",
  component: () => import("@/pages/reports/AccountReceivableAgingCardLedger.vue")
},{
  path: "/reports/account-payable-interim",
  name: "ApInterimReport",
  component: () => import("@/pages/reports/AccountPayableInterim.vue")
}, {
  path: "/reports/account-payable-interim-aging",
  name: "ApInterimAgingReport",
  component: () => import("@/pages/reports/AccountPayableInterimAging.vue")
}, {
  path: "/reports/account-payable-payment-list",
  name: "ApPaymentListReport",
  component: () => import("@/pages/reports/AccountPayablePaymentList.vue")
}, {
  path: "/reports/inventory-account-balance-detail",
  name: "InventoryAccountBalanceDetailReport",
  component: () => import("@/pages/reports/InventoryAccountBalanceDetail.vue")
}, {
  path: "/reports/stock-on-hand",
  name: "StockOnHandReport",
  component: () => import("@/pages/reports/StockOnHand.vue")
}, {
  path: "/reports/top-purchase-item",
  name: "TopPurchaseItemReport",
  component: () => import("@/pages/reports/TopPurchaseItem.vue")
}, {
  path: "/reports/daily-flash-cost",
  name: "DailyFlashCostReport",
  component: () => import("@/pages/reports/DailyFlashCost.vue")
}, {
  path: "/reports/slow-moving-inventory",
  name: "SlowMovingInventory",
  component: () => import("@/pages/reports/SlowMovingInventory.vue")
}, {
  path: "/reports/item-expense",
  name: "ItemExpense",
  component: () => import("@/pages/reports/ItemExpense.vue")
}, {
  path: "/reports/purchase-receiving",
  name: "ApReceivingReport",
  component: () => import("@/pages/reports/PurchaseReceiving.vue")
}, {
  path: "/reports/account-receivable-payment-list",
  name: "ArPaymentListReport",
  component: () => import("@/pages/reports/AccountReceivablePaymentList.vue")
}, {
  path: "/reports/account-receivable-payment-list-card",
  name: "ArPaymentListCardReport",
  component: () => import("@/pages/reports/AccountReceivablePaymentListCard.vue")
}, {
  path: "/reports/account-receivable-payment-list-ledger",
  name: "ArPaymentListLedgerReport",
  component: () => import("@/pages/reports/AccountReceivablePaymentListLedger.vue")
}, {
  path: "/reports/inventory-reconciliation",
  name: "InventoryReconciliation",
  component: () => import("@/pages/reports/InventoryReconciliation.vue")
}, {
  path: "/reports/card-aging",
  name: "CardAgingReport",
  component: () => import("@/pages/reports/CardAgingReport.vue")
}, {
  path: "/reports/item-reorder",
  name: "ItemReorder",
  component: () => import("@/pages/reports/ItemReorder.vue")
},
{
  path: "/reports/top-purchase-by-vendor",
  name: "TopPurchaseByVendor",
  component: () => import("@/pages/reports/TopPurchaseByVendor.vue")
},
{
  path: "/reports/outstanding-purchase-order",
  name: "OutstandingPurchaseOrder",
  component: () => import("@/pages/reports/OutstandingPurchaseOrder.vue")
},
{
  path: "/reports/force-closed-purchase-order",
  name: "ForceClosedPurchaseOrder",
  component: () => import("@/pages/reports/ForceClosedPurchaseOrder.vue")
},
{
  path: "/reports/ar-aging-discrepancy",
  name: "ARAgingDiscrepancy",
  component: () => import("@/pages/reports/ARAgingDiscrepancyReport.vue")
},
{
  path: "/reports/ap-aging-discrepancy",
  name: "APAgingDiscrepancy",
  component: () => import("@/pages/reports/APAgingDiscrepancyReport.vue")
},
  // {
  //   path: "/reports/inventory-food-discrepancy",
  //   name: "InventoryFoodDiscrepancy",
  //   component: () => import("@/pages/reports/DiscrepancyInventoryFnB.vue")
  // },
  // {
  //   path: "/reports/inventory-beverage-discrepancy",
  //   name: "InventoryBeverageDiscrepancy",
  //   component: () => import("@/pages/reports/DiscrepancyInventoryFnB.vue")
  // },
  {
    path: "/reports/iab-soh-discrepancy",
    name: "InventoryAccBalanceSOHDiscrepancy",
    component: () => import("@/pages/reports/DiscrepancyInventoryAccSOH.vue")
  },
  {
    path: "/reports/bank-account-aging-discrepancy",
    name: "BankAccountAgingDiscrepancy",
    component: () => import("@/pages/reports/BankAccountAgingDiscrepancyReport.vue")
  }, 
  {
    path: "/reports/inventory-movement",
    name: "InventoryMovementReport",
    component: () => import("@/pages/reports/InventoryMovementReport.vue")
  },
  {
    path: "/reports/item-consumption",
    name: "ItemConsumption",
    component: () => import("@/pages/reports/ItemConsumption.vue")
  },
  {
    path: "/reports/interface-journal/amandaru",
    name: "InterfaceJournal",
    component: () => import("@/pages/reports/AmandaruInterfaceJournal.vue")
  }
];
